import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import {tipsClose} from '~/modules/tips/actions';

import css from './index.css';

class Tips extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.tipsCloseUI = (uriTips, contextTips) => props.dispatch(tipsClose(uriTips, contextTips));
  }
  render() {
    if (!this.props.contextTips) {
      return null;
    }
    let type = 'success';
    if (this.props.uriTips.type === 'success') {
      type = 'success';
    } else if (this.props.uriTips.type === 'failed') {
      type = 'failed';
    }
    return (
      <div className={cs(css.tipsWrap)} data-qa='tipsToast'>
        <div className={cs(css.block, css[`${type}-block`])}>
          <p className={css.content} dangerouslySetInnerHTML={{__html: this.props.contextTips}} />
        </div>
      </div>
    );
  }
  close() {
    this.tipsCloseUI(this.props.uriTips, false);
  }
}

export default connect(({tips}) => ({
  uriTips: tips.uriTips,
  contextTips: tips.contextTips,
}), null)(Tips);




// WEBPACK FOOTER //
// ./src/components/Tips/index.js